import type { RefObject } from 'react';
import { getRowHeights } from './get-row-heights';

export const updateRowHeight = (
  carouselRef: RefObject<HTMLDivElement>,
  rows: number
) => {
  const { current } = carouselRef;

  if (!current) {
    return;
  }

  const rowHeights = getRowHeights(carouselRef, rows);

  current.childNodes.forEach((column) => {
    rowHeights.forEach((rowHeights, i) => {
      const currentRow = column.childNodes[i] as HTMLElement;

      if (currentRow) {
        currentRow.style.height = `${rowHeights}px`;
      }
    });
  });
};
